var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Snackbar from '@material-ui/core/Snackbar';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MuiAlert from '@material-ui/lab/Alert';
import { useAlertText, useAlertType, useLanguage, useIsAlertOpen } from '../hooks';
import { Language } from '../types';
var Alert = function () {
    var mediaQuery = useMediaQuery('(max-width: 500px)');
    var classes = useStyles();
    var _a = useIsAlertOpen(), isOpen = _a[0], setIsOpen = _a[1];
    var text = useAlertText()[0];
    var type = useAlertType()[0];
    var language = useLanguage();
    return (_jsx(Snackbar, __assign({ open: isOpen, autoHideDuration: 6000, className: classes.snackbar, onClose: function () { return setIsOpen(false); }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: mediaQuery ? 'center' : language === Language.He ? 'right' : 'left'
        } }, { children: _jsx(MuiAlert, __assign({ variant: "filled", severity: type, className: classes.alert, onClose: function () { return setIsOpen(false); } }, { children: text }), void 0) }), void 0));
};
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return ({
        snackbar: (_a = {},
            _a[theme.breakpoints.down(500)] = {
                margin: '3vw 2vw'
            },
            _a),
        alert: (_b = {
                boxShadow: 'gray 0 3px 6px',
                alignItems: 'center'
            },
            _b[theme.breakpoints.down(500)] = {
                fontSize: '5vw'
            },
            _b)
    });
});
export default Alert;
//# sourceMappingURL=Alert.js.map